import axios from "axios";
import { useQuery } from "react-query";

export type AdjustmentReason = {
  code: string;
  name: string;
};

interface ReasonsResponse {
  reasons: AdjustmentReason[];
}

const getAdjustmentReasons = () =>
  axios.get<ReasonsResponse>("adjustments/reasons").then((response) => {
    const adjustmentReasonsByCode = response.data.reasons.reduce(
      (res, item) => {
        res[item.code] = item;
        return res;
      },
      {} as Record<string, AdjustmentReason>
    );

    const adjustmentReasonsVariants = response.data.reasons.map(
      ({ code, name }) => ({
        id: code,
        value: code,
        title: name,
      })
    );

    return {
      adjustmentReasonsByCode,
      adjustmentReasonsVariants,
    };
  });

const useAdjustmentReasons = (enabled: boolean) =>
  useQuery("adjustmentReasons", getAdjustmentReasons, {
    staleTime: Infinity,
    enabled,
  });

export default useAdjustmentReasons;
